





























import { Component, Vue, Emit, Prop, Provide } from "vue-property-decorator";
import { State, Getter, Action, namespace } from "vuex-class";
import { IPortalUser } from "../../../models/interfaces/authentication/portal-user.model.interface";
import Loader from "@/components/Loader.vue";

const UserManagementModule = namespace("userManagementModule");

@Component({
    components: {
        Loader
    }
})
export default class UserManagementTable extends Vue {
    @UserManagementModule.Getter public registeredUsers: IPortalUser[];
    @UserManagementModule.Action public retrieveUsers;

    @Prop({ default: "Table" })
    public caption: string;

    @Prop({ default: false })
    public hover: boolean;

    @Prop({ default: false })
    public striped: boolean;

    @Prop({ default: false })
    public bordered: boolean;

    @Prop({ default: false })
    public small: boolean;

    @Prop({ default: false })
    public fixed: boolean;

    @Provide() public items: IPortalUser[] = [];

    @Provide()
    public columns = [
        {
            key: "emailAddress",
            formatter: (value, key, item) => {
                return item;
            }
        },
        { key: "fullName" },
        { key: "registrationDate" },
        { key: "lastLoginDate" },
        { key: "role.name" },
        {
            key: "status",
            formatter: (value, key, item) => {
                return item;
            }
        }
    ];

    @Provide() public currentPage = 1;
    @Provide() public perPage = 5;
    @Provide() public totalRows = 0;

    private loading: boolean = true;

    public created() {
        this.retrieveUsers().then((result) => {
            if (result === true) {
                this.items = this.registeredUsers;
                this.loading = false;
            }
        });
    }

    public getAuthorisedBadgeType(authorised: boolean) {
        return authorised === true ? "success" : "danger";
    }

    public getAuthorisedBadgeText(authorised: boolean) {
        return authorised === true ? "Authorised" : "Unauthorised";
    }

    public getRowCount() {
        return this.items.length;
    }
}
